export default __webpack_public_path__ + "static/media/Trapper's Hook.a8a7d2a7.jpg";